<template>
  <div class="partners">
    <h2>Our partners</h2>
    <div class="partners-pictures">
      <a href="https://research.qut.edu.au/designlab/" target="_blank" @click="logPartnerClicks('QUT')">
        <div
          class="partner"
          style="
            background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/DL-Blue-Logo-white-background.jpg');
          "
        ></div>
      </a>
      <a href="https://cbcs.centre.uq.edu.au/" target="_blank" @click="logPartnerClicks('UQ')">
        <div
          class="partner"
          style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/UQlogo-Purple-rgb.png')"
        ></div>
      </a>
    </div>
    <p>To learn more about our partners <a href="https://www.wwf.org.au/news/blogs/thanks-to-our-my-backyard-partners" target="_blank">click here</a></p>
  </div>
</template>
  
<script>
export default {
  name: "Partners",
  // data() {},
  methods: {
    async logPartnerClicks(partner) {
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Our Partners Clicks",
        eventProperties: { "Partner Name ": partner },
      });
    } 
  }
};
</script>

<style>
.partners {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background-color: #fbfbfa;
}

h2 {
  margin: 0;
}

.partners .partners-pictures {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.partners .partners-pictures .partner {
  width: 250px;
  height: 80px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 30px;
}

@media only screen and (max-width: 600px) {
  .partners-pictures {
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// Partners.vue?68f45904